import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import { LibrarySagaActions } from '../actions'
import { syncProjectLibrary } from './syncProjectLibrary'

/**
 * Someone changed the library: the socket says which workspace and kind, the
 * data is re-read — the own list for a member, the referenced items for anyone
 * who has the project open.
 */
export function* invalidateLibrary({
  payload: { workspaceId, kind },
}: ReturnType<typeof LibrarySagaActions.invalidate>) {
  const ownWorkspaceId: string | null = yield select(
    migrationProjectSelector.getProjectWorkspaceId
  )

  if (ownWorkspaceId === workspaceId) {
    yield put(LibrarySagaActions.fetch({ kind }))
  }

  yield call(syncProjectLibrary)
}
